import { Typography, Stack, IconButton } from "@mui/material";
import { Box } from "@mui/system";
import Layout from "../../components/Layout/Layout";
import classes from "../../styles/CheckinFormStyle";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { useNavigate } from "react-router-dom";
import CheckInWrapper from "./components/CheckInWrapper";

const CheckInHistory = () => {
    const navigate = useNavigate()

    return (
        <Layout>
            <Box sx={classes.headWithBtn}>
                <Stack direction="row" gap="2rem">
                    <IconButton
                        sx={classes.backArrow}
                        disableRipple
                        onClick={() => {
                            navigate(-1)
                        }}
                    >
                        <ArrowRightAltIcon />
                    </IconButton>

                    <Typography variant="h2" component="h2">
                        Check-In History
                    </Typography>
                </Stack>
            </Box>

            <Box bgcolor={"#fff"} width={"100%"} borderRadius={4} mt={3} pb={6}>
                <CheckInWrapper />
            </Box>
        </Layout>
    );
};

export default CheckInHistory;